<template>
  <component :is="isEditing?'Moveable':'div'"
    ref="moveable"
    class="moveable"
    v-bind="isSlected?moveable:unmoveable"
    :style="position"
    :container="container"
    :bounds="bounds"
    @drag="handleDrag"
    @dragEnd="save"
    @resizeStart="handleResizeStart"
    @resize="handleResize"
    @resizeEnd="resizeEnd"
    @scale="handleScale"
    @scaleEnd="save"
    @rotate="handleRotate"
    @rotateEnd="save"
  >
    <div style="width:100%; height:100%; position: absolute;" :class="{snapableClass:!isSlected,notSnapableClass:isSlected}">
      <div style="width:100%; height:100%; position: absolute;">
        <slot></slot>
      </div>
    </div>
  </component>
</template>
<style lang="less" scoped>
.moveable {
  position: absolute;
  // transform-origin:50% 50% 0;
}
</style>
<script>
import Moveable from "vue-moveable";
export default {
  props: ["config", "isSlected", "bounds", "container", "isEditing", "cellStep"],
  data() {
    return {
      toolScale:1,
      moveable: {
        draggable: true,
        throttleDrag: 0,
        resizable: true,
        throttleResize: 0,
        keepRatio: false,
        scalable: false,
        throttleScale: 0,
        rotatable: true,
        throttleRotate: 0,
        pinchable: true, // ["draggable", "resizable", "scalable", "rotatable"]
        origin: false,
        snappable: true,
        elementGuidelines:[],
      },
      unmoveable: {
        draggable: false,
        throttleDrag: 0,
        resizable: false,
        throttleResize: 0,
        keepRatio: false,
        scalable: false,
        throttleScale: 0,
        rotatable: false,
        throttleRotate: 0,
        pinchable: false, // ["draggable", "resizable", "scalable", "rotatable"]
        origin: false,
        scrollable: false
      }
    };
  },
  components: {
    Moveable
  },

  watch: {
    isSlected:{
      handler(){
        if(this.isSlected){
          this.$nextTick().then(()=>{
            this.updateMoveableConfig();
          })
        }
      }
    }
  },

  computed:{
      position(){
          if(this.$refs&&this.$refs.moveable){
            setTimeout(() => {
              this.$refs.moveable.moveable.updateRect()  
            }, 0);
          }
          return {
            width:this.config.position.width+"px",
            height:this.config.position.height+"px",
            transform:this.toTransform(this.config&&this.config.position)
          }
      },
      
  },

  mounted(){
    this.updateThrottles();
  },
  methods: {
    handleDrag({ delta, inputEvent, target }) {
      // debugger
    //   target.style.transform = transform;
      inputEvent.stopPropagation();
      let distX = delta[0]*target.offsetWidth/target.getBoundingClientRect().width///Math.cos(this.config.position.rotate*0.017453293);
      let distY = delta[1]*target.offsetHeight/target.getBoundingClientRect().height//(Math.sin(this.config.position.rotate*0.017453293)/1);
      this.config.position.translateX += Math.round(distX);
      this.config.position.translateY += Math.round(distY);
    },
    handleResize({ target, delta }) {
      let distX = delta[0]*target.offsetWidth/target.getBoundingClientRect().width;
      let distY = delta[1]*target.offsetHeight/target.getBoundingClientRect().height;
      if(delta[0]){
          this.config.position.width += Math.round(distX);
      }
      if(delta[1]){
          this.config.position.height += Math.round(distY);
      }
    },

    handleResizeStart({direction, setOrigin}){
      // console.log(arguments);
      
    },
    resizeEnd(){
      this.$emit("on-slot-resize");
      this.save();
    },
    handleScale({ target, transform, delta, scale }) {
    //   let distX = (delta[0]-1)*target.offsetWidth/target.getBoundingClientRect().width;
    //   let distY = (delta[1]-1)*target.offsetHeight/target.getBoundingClientRect().height;
    //TODO: 缩放比例有问题， 缩放后drag会不跟随
      if(delta[0]){
          this.config.position.scaleX = scale[0];
      }
      if(delta[1]){
          this.config.position.scaleY = scale[1];
      }
    },
    handleRotate({ target, dist, transform }) {
      this.config.position.rotate = dist;
    },
    toTransform(position){
      const {translateX=0, translateY=0, rotate=0, scaleX=1, scaleY=1} = position;
      return `translateX(${translateX}px) translateY(${translateY}px) rotate(${rotate}deg) scaleX(${scaleX}) scaleY(${scaleY})`;
    },
    save(){
      this.$emit("save");
    },
    updateMoveableConfig(){
      this.updateThrottles();
      let es = this.container.querySelectorAll('.snapableClass');
      let notes = new Set(this.container.querySelector('.notSnapableClass').querySelectorAll('.snapableClass'));
      // console.log(notes);
      
      let diff = Array.prototype.filter.call(es, x=>!notes.has(x));
      this.moveable.elementGuidelines = diff;
    },

    updateThrottles(){
      // if(this.isEditing){
      //   // this.toolScale = this.$refs.moveable.$el.offsetWidth/this.$refs.moveable.$el.getBoundingClientRect().width;  
      //   // this.moveable.throttleDrag = this.cellStep/this.toolScale;
      //   // this.moveable.throttleResize = this.moveable.throttleDrag;
      // }
    }
  }
};
</script>